import CampusInfoActionCard from "../_local/components/NewCards/CampusInfoActionCard";
import React from "react";
import TemplateMedaiActionCard from '../_local/components/NewCards/TemplateMediaActionCard';

const TemplateMediaPreview = () => {
    const templateMedia: any[] = JSON.parse(sessionStorage.getItem("templateMedia")) || [];

    if (!templateMedia || templateMedia.length === 0) {
        return <p className="text-gray-500">No Template Media information added yet.</p>;
    }

    return (
        <div className="space-y-4">
            {templateMedia.map((media, index) => (
                <TemplateMedaiActionCard
                    element={media}
                    handleOpenDrawer={() => { }}
                    disableAddPhotos
                />
            ))}
        </div>
    );
};

export default TemplateMediaPreview;